<template>
  <v-card>
    <v-card-subtitle>
      <strong>Designated Yards</strong>
    </v-card-subtitle>
    <v-data-table
      :headers="yardTableHeaders"
      :items="yards"
    >
      <template v-slot:item.has_brokerage_terms="{ item }">
        <v-chip
          v-if="item.brokerageterm"
          small
          color="success"
          text-color="white"
        >
          Has Terms
        </v-chip>
        <v-chip
          v-else
          small
          color="warning"
          text-color="white"
        >
          No Terms
        </v-chip>
      </template>
    </v-data-table>
    <auth-guard
      can="api.change_lot"
      type="hidden"
    >
      <v-btn
        color="primary"
        small
        fab
        absolute
        bottom
        right
        @click="editDialog = !editDialog"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </auth-guard>
    <edit-dialog
      v-model="editDialog"
      headline-text="Update Designated Yards"
      @accept="updateYards"
    >
      <search-autocomplete
        v-model="chipYards"
        label="Search for Yard(s)"
        api-path="/api/lots/yard_search/"
        multiple
        :format-entry="addFriendlyName"
      />
    </edit-dialog>
  </v-card>
</template>

<script>
import axios from 'axios'
import SearchAutocomplete from '@/base/components/SearchAutocomplete.vue'

export default {
  name: 'DesignatedYards',
  components: { SearchAutocomplete },
  data: () => ({
    editDialog: false,
    chipYards: [],
    yardTableHeaders: [
      { text: 'Name', value: 'name' },
      { text: 'Address', value: 'full_address' },
      { text: 'Brokerage Terms', value: 'has_brokerage_terms' }
    ]
  }),
  props: {
    yards: { type: Array, required: false, default: () => ([]) },
    url: { type: String, required: true }
  },
  watch: {
    editDialog (opened) {
      if (opened) this.chipYards = this.yards.map(this.addFriendlyName)
    }
  },
  methods: {
    addFriendlyName (x) {
      return Object.assign({}, x, { friendlyName: `${x.id} - ${x.name} | ${x.full_address || ''} | ${x.status}${x.brokerageterm ? ' (Has Terms)' : ''}` })
    },
    updateYards () {
      axios.patch(this.url, { yards: this.chipYards.map(h => h.id) }).then(() => {
        this.$emit('fetchLot')
      })
    }
  }
}
</script>
